import { useContext, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../Context/GlobalContext";

const API = {
  LIST: "/Inventory/v1.0/getRackDetails",
  ADD: "/Inventory/v1.0/insertRackDetails",
  DEL: "/Inventory/v1.0/deleteRackDetails",
};

export default function useRack() {
  const { api, userID } = useContext(GlobalContext);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const postRequest = useCallback(
    async (endpoint, payload) => {
      const response = await api.post(endpoint, payload);
      return response?.data;
    },
    [api]
  );

  const fetchRacks = async () => {
    if (!userID) return;

    try {
      setLoading(true);

      const data = await postRequest(API.LIST, {
        userid: userID,
      });

      if (data?.responseCode === "00") {
        setRows(
          Array.isArray(data?.response)
            ? data.response
            : []
        );
      } else {
        setRows([]);
        toast.error(
          data?.responseMessage ||
            "Failed to fetch racks"
        );
      }
    } catch (err) {
      console.error(err);
      toast.error("API error while fetching racks");
    } finally {
      setLoading(false);
    }
  };

  const addRack = async (payload) => {
    try {
      const finalPayload = {
        ...payload,
        userid: payload.userid || userID,
      };

      const data = await postRequest(
        API.ADD,
        finalPayload
      );

      if (data?.responseCode === "00") {
        toast.success(
          data?.responseMessage || "Rack added"
        );

        await fetchRacks();

        return true;
      }

      toast.error(
        data?.responseMessage || "Add failed"
      );

      return false;
    } catch (err) {
      console.error(err);
      toast.error("API error while adding rack");
      return false;
    }
  };

  const deleteRack = async (rackId) => {
    try {
      const data = await postRequest(
        API.DEL,
        {
          rackId: String(rackId),
          userid: userID,
        }
      );

      if (data?.responseCode === "00") {
        toast.success(
          data?.responseMessage ||
            "Rack deleted successfully"
        );

        await fetchRacks();
      } else {
        toast.error(
          data?.responseMessage ||
            "Delete failed"
        );
      }
    } catch (err) {
      console.error(err);
      toast.error("API error while deleting rack");
    }
  };

  return {
    rows,
    loading,
    fetchRacks,
    addRack,
    deleteRack,
  };
}